export default "__VITE_ASSET__BM4WBjZc__"